import React, { FC, ReactNode } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

interface AlertDialogProps {
  title: string;
  content: ReactNode;
  cancelButtonText: string;
  submitButtonText: string;
  onCancel: () => void;
  onSubmit: () => void;
}

const AlertDialog: FC<AlertDialogProps> = ({
  title,
  content,
  cancelButtonText,
  submitButtonText,
  onCancel,
  onSubmit,
}) => {
  return (
    <Dialog open onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions style={{ padding: '8px 24px 16px 24px' }}>
        <Button onClick={onCancel} color="primary" variant="outlined">
          {cancelButtonText}
        </Button>
        <Button onClick={onSubmit} color="primary" variant="contained">
          {submitButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
